/**
 * authValidation.ts — Zod-Schemas für die Auth-Formulare.
 *
 * Client-seitige Validierung; Supabase erzwingt die Passwort-Policy
 * (minimum_password_length = 12, siehe supabase/config.toml) zusätzlich
 * serverseitig.
 */

import { z } from 'zod';
import { de } from './i18n/de';

export const MIN_PASSWORD_LENGTH = 12;

export const emailSchema = z.string().trim().toLowerCase().email(de.authValidation.emailInvalid);

export const passwordSchema = z
  .string()
  .min(MIN_PASSWORD_LENGTH, de.authValidation.passwordTooShort);

export const passwordPairSchema = z
  .object({
    password: passwordSchema,
    passwordRepeat: z.string(),
  })
  .refine((v) => v.password === v.passwordRepeat, {
    message: de.authValidation.passwordMismatch,
    path: ['passwordRepeat'],
  });

/** Erste Fehlermeldung eines fehlgeschlagenen Parse — für Inline-Anzeige. */
export function firstIssueMessage(result: { success: false; error: z.ZodError }): string {
  return result.error.issues[0]?.message ?? de.authValidation.emailInvalid;
}
